module.exports = __webpack_public_path__ + "static/img/unit1.11d00a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit1.png
// module id = +FMN
// module chunks = 1